import React, { useEffect, useState } from "react";
import { getBegabungAngebotePage } from "../lib/api";
import { Page, PageHeader, Section, SectionHead, IntroSplit, CardGrid, MediaCard } from "../components/ui";

export default function BegabungAngebotePage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getBegabungAngebotePage()
      .then((res) => !cancelled && setData(res))
      .catch((err) => !cancelled && setError(err));
    return () => {
      cancelled = true;
    };
  }, []);

  const {
    heroTitle,
    heroSubtitle,
    introKicker,
    introTitle,
    introText,
    introImage,
    vormittagTitle,
    vormittagSubtitle,
    vormittagskurse,
    nachmittagTitle,
    nachmittagSubtitle,
    nachmittagskurse,
  } = data || {};

  return (
    <Page loading={!data} error={error}>
      <PageHeader
        parent={{ label: "Begabungsförderung", to: "/" }}
        current="Angebote & Kurse"
        title={heroTitle}
        subtitle={heroSubtitle}
      />

      <Section intro>
        <IntroSplit image={introImage} kicker={introKicker} title={introTitle} text={introText} />
      </Section>

      {/* Vormittagskurse — Karten mit Foto & Piktogramm */}
      <Section>
        <SectionHead title={vormittagTitle} subtitle={vormittagSubtitle} />
        <CardGrid cols={3}>
          {(vormittagskurse || []).map((kurs, i) => (
            <MediaCard
              key={kurs.id ?? i}
              image={kurs.image}
              iconName={kurs.iconName}
              title={kurs.title}
              text={kurs.text}
            />
          ))}
        </CardGrid>
      </Section>

      {/* Nachmittagskurse — Karten mit Foto & Piktogramm */}
      <Section>
        <SectionHead title={nachmittagTitle} subtitle={nachmittagSubtitle} />
        <CardGrid cols={3}>
          {(nachmittagskurse || []).map((kurs, i) => (
            <MediaCard
              key={kurs.id ?? i}
              image={kurs.image}
              iconName={kurs.iconName}
              title={kurs.title}
              text={kurs.text}
            />
          ))}
        </CardGrid>
      </Section>
    </Page>
  );
}